import _regeneratorRuntime from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
* plugins
* */
import axios from "~/plugins/axios";

/*
* components
* */

var dummyMsList = [{
    moduleName: 'IFW-SIC',
    language: 'English',
    roomId: 1,
    seatLeft: 22,
    trainerName: 'trainer name'
}, {
    moduleName: 'IFW-SIC',
    language: 'English',
    roomId: 2,
    seatLeft: 22,
    trainerName: 'trainer name'
}, {
    moduleName: 'IFW-SIC',
    language: 'English',
    roomId: 3,
    seatLeft: 22,
    trainerName: 'trainer name'
}, {
    moduleName: 'IFW-SIC',
    language: 'English',
    roomId: 4,
    seatLeft: 22,
    trainerName: 'trainer name'
}, {
    moduleName: 'IFW-SIC',
    language: 'English',
    roomId: 5,
    seatLeft: 22,
    trainerName: 'trainer name'
}, {
    moduleName: 'IFW-SIC',
    language: 'English',
    roomId: 6,
    seatLeft: 22,
    trainerName: 'trainer name'
}];

export default {
    name: "tv-calendar",
    components: {},

    fetch: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
            var store = _ref.store,
                redirect = _ref.redirect;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (store.state.authUser) {
                                _context.next = 2;
                                break;
                            }

                            return _context.abrupt('return', redirect('/'));

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function fetch(_x) {
            return _ref2.apply(this, arguments);
        }

        return fetch;
    }(),
    data: function data() {
        return {
            announcement: "",
            mark: 'this is TV Calendar',
            currentDateRaw: this.$moment(new Date()).format('YYYYMMDD').toString(),
            moduleSessionList: [],
            //dummyMsList: moduleSessionList,
            todayMsFields: {
                moduleName: { label: 'Module', key: 'moduleName', sortable: true },
                language: { label: 'Language', key: 'language' },
                roomId: { label: 'RoomID', key: 'roomId' },
                trainerName: { label: 'Trainer', key: 'trainerName' },
                sessionTimeRaw: { label: "Time", key: "sessionTimeRaw", sortable: true }
            },
            totalRows: !!this.moduleSessionList ? this.moduleSessionList.length : 20,
            perPage: 20,
            currentPage: 1,
            showInput: false
        };
    },
    mounted: function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return this.initModuleSessionList();

                        case 2:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function mounted() {
            return _ref3.apply(this, arguments);
        }

        return mounted;
    }(),


    methods: {
        changePage: function changePage() {
            if (this.currentPage < Math.ceil(this.totalRows / this.perPage)) {
                this.currentPage++;
            } else if (this.currentPage == Math.ceil(this.totalRows / this.perPage)) {
                this.currentPage = 1;
            }
        },
        showInputAnn: function showInputAnn() {
            var inputAnn = document.querySelector('#input-ann');
            inputAnn.className == 'hide-input' ? inputAnn.className = '' : inputAnn.className = 'hide-input';
        },
        initModuleSessionList: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                var moduleSessionList;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return axios.post('/moduleSession/', { currentDateRaw: this.currentDateRaw, moduleName: null });

                            case 2:
                                moduleSessionList = _context3.sent.data.moduleSessionList;


                                this.moduleSessionList = moduleSessionList;

                                console.log('\n\n====== current date ======\n', this.currentDateRaw, '\n========');
                                console.log('\n\n====== module session list of the day ======\n', moduleSessionList, '\n========');

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function initModuleSessionList() {
                return _ref4.apply(this, arguments);
            }

            return initModuleSessionList;
        }(),
        updateTrainerName: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(event, trainerName, msId) {
                var returnInfo;
                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                console.log(trainerName);
                                console.log(msId);

                                _context4.next = 4;
                                return axios.post("/moduleSession/tvcalSetTrainerName", { newTrainerName: trainerName, msId: msId });

                            case 4:
                                returnInfo = _context4.sent.data;

                                this.showInput = false;
                                alert(returnInfo.info);

                            case 7:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function updateTrainerName(_x2, _x3, _x4) {
                return _ref5.apply(this, arguments);
            }

            return updateTrainerName;
        }()
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/tvCalendar.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/tvCalendar.vue
// module chunks = 15